import React, { useState, useRef} from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonButton, IonItem, IonList, IonInput, IonModal, IonLabel, IonSlides, IonSlide } from '@ionic/react';

import {MerchantLoginCredentials } from '../components/LoginCredentials_merchant'
//import { AuthenticatedMerchantProvider } from '../../../storeState/auth_merchantID_context'


 //export class MerchantLogin extends React.Component {
 export function MerchantLogin (props) {

    const [showCreateAccount, setShowCreateAccount ] = useState(false);
    const [isLoaded, setIsLoaded ] = useState(false);
    const [acctID, setAccountID ] = useState(null);
    const [employeeID, setEmployeeID ] = useState(null);
    const [schema, setSchema ] = useState(null);
    const [authenticated, setAuthenticated ] = useState(null);
    const [accessRights, setAccessRights ] = useState(null);
    const [baseURL, setBaseURL] = useState(null)

    let businessTypeSelectionRef = useRef();
    let companyNameRef = useRef();
    let companyAddressNumberRef = useRef();
    let companyStreetNameRef = useRef();
    let companyCityRef = useRef();
    let companyCityDistrictRef = useRef();
    //let companyNearestLandmarkRef = useRef();
    let companyDigitalAddressRef = useRef();
    let companyCountryRegionRef = useRef();
    let companyPhoneNumberRef = useRef();
    let companyAdminEmailRef = useRef();
    let createUsernameRef = useRef();
    let createPasswordRef = useRef();




    function handleCreateAccount() {


        const requestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
             },
            body: JSON.stringify({
                Tracker: '72001',
                uEnterBusinessType: businessTypeSelectionRef.current.value,
                uCompanyName: companyNameRef.current.value,
                uCompanyAddressNumber: companyAddressNumberRef.current.value,
                uCompanyStreetName: companyStreetNameRef.current.value,
                uCompanyAddressCity: companyCityRef.current.value,
                uCompanyCityDistrict: companyCityDistrictRef.current.value,
                uCompanyNearestLandmark: companyDigitalAddressRef.current.value,
                uCompanyCountryRegion: companyCountryRegionRef.current.value,
                uCompanyMobileNumber: companyPhoneNumberRef.current.value,
                uCompanyAdminEmail: companyAdminEmailRef.current.value,
                uCreateUsername: createUsernameRef.current.value,
                uCreatePassword: createPasswordRef.current.value,

            })
        }

        fetch(baseURL+"merchants_argsApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            
            setShowCreateAccount(false);
        })
    }

    //function handleAuthentication(event) {

    //    props.onHandleUserAuthentication(event);
    //}


  //render() {

    //alert('Inside MerchantLogin');

    /*function onAuthHandler(e) {

        props.onAuthenticated(e);
    }*/

    //alert('In merchantLogin');

    alert('In MerchantLogin.js');

    return (
      //{/*<IonPage>*/}
      //<div className='ion-page'>

      <React.Fragment>

                <MerchantLoginCredentials  /> 
                    
              {/*<IonModal id='createAccountModal' isOpen={showCreateAccount}>
                <IonSlides pager="true">
                    <IonSlide>
                        <IonItem>
                            <IonLabel for="merchantBusinessFunction">Business Type </IonLabel>
                            <select name="merchantBusinessFunction" id='merchantBusinessFunction' ref={businessTypeSelectionRef }>
                                <option value='T1'>Professional Services</option>
                                <option value='T2'>Hotel Services</option>
                                <option value='T3'>Restaurant Services</option>
                                <option value='T4'>Retail Services</option>
                            </select>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Company Name: </IonLabel>
                            <IonInput placeholder='Enter Company Name' ref={companyNameRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Address Number: </IonLabel>
                            <IonInput placeholder='Enter Company Phone Number' ref={companyAddressNumberRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Address Street Name: </IonLabel>
                            <IonInput placeholder='Enter Company Phone Number' ref={companyStreetNameRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>City: </IonLabel>
                            <IonInput placeholder='Enter Company Phone Number' ref={companyCityRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>City District: </IonLabel>
                            <IonInput placeholder='Enter Company Phone Number' ref={companyCityDistrictRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Digital Address: </IonLabel>
                            <IonInput placeholder='Enter Digital Address' ref={companyDigitalAddressRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Ghana - Country Region: </IonLabel>
                            <IonInput placeholder='Enter Company Phone Number' ref={companyCountryRegionRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Company Phone Number: </IonLabel>
                            <IonInput placeholder='Enter Company Phone Number' ref={companyPhoneNumberRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Admin Email: </IonLabel>
                            <IonInput placeholder='Enter Company Phone Number' ref={companyAdminEmailRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Admin Username: </IonLabel>
                            <IonInput placeholder='Enter Username' ref={createUsernameRef }></IonInput>
                        </IonItem>
                    </IonSlide>
                    <IonSlide>
                        <IonItem>
                            <IonLabel>Admin Password: </IonLabel>
                            <IonInput placeholder='Enter Password' ref={createPasswordRef }></IonInput>
                        </IonItem>
                        <IonButton onClick={ handleCreateAccount }> Submit </IonButton>
                    </IonSlide>
                </IonSlides>
                <IonButton onClick={() => setShowCreateAccount(false)}> Cancel </IonButton>
            </IonModal>
            <IonButton onClick={() => setShowCreateAccount(true)}>
                    Create Account
            </IonButton>*/}
        </React.Fragment>
    );
};



export default MerchantLogin;